import { ContentPageFeature } from '../ContentPage/ContentPageFeature';

export const HomePageFeature: React.FC<Content.HomePage> = (page) => <ContentPageFeature {...page} />;
